import {
    Card,
    CardHeader,
    CardFooter,
    CardTitle,
    CardDescription,
    CardContent,
} from "@/components/ui/card";
import { useTRPC } from "@/trpc";
import { useQuery } from "@tanstack/react-query";
import { Label } from "@/components/ui/label";

interface BasePlayerInformation {
    id: string;
    playerId: string;
    playerImpectId: string;
    name?: string;
    start_position?: string;
    position?: string;
    shirt_number?: number;
    is_starter?: boolean;
    side_id: string;
}

interface Props {
    Player: BasePlayerInformation | undefined;
}

const PlayerFormationCard = ({ Player }: Props) => {
    const { trpc } = useTRPC();

    const { data: playerEvents } = useQuery({
        queryKey: ['playerEvents', Player?.playerId],
        queryFn: () => trpc.matches.playerEvents.getById.query({ id: Player?.side_id ?? "", playerId: Player?.playerImpectId ?? "" }),
        enabled: !!Player?.playerId,
    });

    return (
        <Card className="w-full m-4 flex-1/2">
            <CardHeader>
                <CardTitle>{Player?.name ?? "Selecteer een speler"}</CardTitle>
            </CardHeader>
            <CardContent className="text-sm space-y-2">
                <div className="flex flex-col gap-4">
                    <div className="flex flex-col gap-1">
                        <Label>Passen:</Label>
                        <div className="flex flex-row gap-2">
                            <div>Pogingen: {playerEvents?.actions?.PASS.attempted ?? 0}</div>
                            <div>Voltooid: {playerEvents?.actions?.PASS.completed ?? 0}</div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-1">
                        <Label>Schoten:</Label>
                        <div className="flex flex-row gap-2">
                            <div>Pogingen: {playerEvents?.actions?.SHOT.total ?? 0}</div>
                            <div>Gescoord: {playerEvents?.actions?.SHOT.goals ?? 0}</div>
                            <div>Eigen doelpunt: {playerEvents?.actions?.SHOT.own_goals ?? 0}</div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-1">
                        <Label>Dribbles:</Label>
                        <div className="flex flex-row gap-2">
                            <div>Pogingen: {playerEvents?.actions?.DRIBBLE.attempted ?? 0}</div>
                            <div>Geslaagd: {playerEvents?.actions?.DRIBBLE.completed ?? 0}</div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};

export default PlayerFormationCard;